import React, { useEffect, useState } from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CTooltip,
} from "@coreui/react";
import { cilLockLocked, cilUser } from "@coreui/icons";
import CIcon from "@coreui/icons-react";

import dummyAvatar from "../../../assets/avatar.png";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../../features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { removeFcmToken } from "../../../utils/token";
import { deleteToken } from "firebase/messaging";
import { messaging } from "../../../firebase/firebase-config";
import {
  clearUserProfile,
  fetchUserProfile,
} from "../../../features/user/userSlice";

const AppHeaderDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const kycWarningMessage = useSelector((state) => state.ui.kycWarningMessage);
  const { profile } = useSelector((state) => state.user);

  // Add cache-busting to prevent browser caching of profile images
  const getAvatarSrc = () => {
    if (!profile?.profile_image_url) return dummyAvatar;
    const timestamp = new Date().getTime();
    return profile.profile_image_url.includes('?')
      ? `${profile.profile_image_url}&t=${timestamp}`
      : `${profile.profile_image_url}?t=${timestamp}`;
  };

  const avatarSrc = getAvatarSrc();
  // console.log("Profile:", profile);
  const handleProfileClick = () => {
    if (kycWarningMessage) {
      navigate("/seller/upload-kyc");
    } else {
      navigate("/seller/profile");
    }
  };
  const handleLogout = async () => {
    try {
      //Delete FCM token from Firebase (client side)
      if (messaging) {
        await deleteToken(messaging);
        // console.log("FCM token deleted from client");
      }
    } catch (error) {
      console.warn("Error deleting FCM token:", error);
    }
    removeFcmToken();
    dispatch(logoutUser());
    dispatch(clearUserProfile());
  };

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle
        placement="bottom-end"
        className="mt-2 py-0 pe-0"
        caret={false}
      >
        <CTooltip
          content={
            <div style={{ textAlign: "left" }}>
              <div style={{ fontWeight: 600 }}>{profile?.name || "User"}</div>
              <div style={{ fontSize: "12px", opacity: 0.8 }}>
                USER ID: {profile?.public_user_id || "-"}
              </div>
            </div>
          }
          placement="bottom"
          popperConfig={{
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 8],
                },
              },
            ],
          }}
        >
          <CAvatar
            src={avatarSrc}
            size="md"
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "50%",
              overflow: "hidden",
              cursor: "pointer",
            }}
          />
        </CTooltip>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-body-secondary fw-semibold my-2">
          Settings
        </CDropdownHeader>
        <CDropdownItem onClick={handleProfileClick}>
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem>
        {/* <CDropdownItem href="#">
          <CIcon icon={cilSettings} className="me-2" />
          Settings
        </CDropdownItem> */}
        <CDropdownDivider />
        <CDropdownItem onClick={handleLogout}>
          <CIcon icon={cilLockLocked} className="me-2" />
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
